/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { IIconActionButton } from 'app/shared/interfaces/IIconActionButton.interface';
import { ActionableItemState } from 'app/shared/models/actionable-item-state';
import { OrderSearchListItemModel } from './order-search-list-item.model';
import { UsersService } from 'app/modules/configuration/users/user-management/services/users.service';

export class OrderSearchListItemViewModel extends ActionableItemState {
	editButton: IIconActionButton;
	sendConfirmationButton: IIconActionButton;
	constructor(dataModel: OrderSearchListItemModel, userService: UsersService	) {
		super();

		this.dataModel = dataModel;

		this.editButton = {
			visible: true,
			enabled: true,
			actionEnabled: dataModel.canRefund,
			actionDisabledMessage: dataModel.cannotRefundMessage,
			iconName: 'money_off',
			actionName: 'refund',
			hoverText: 'Create Refund',
			class: '',
			buttonText: '',
			popover: '',
		};

		this.sendConfirmationButton = {
			visible: dataModel.canSendConfirmationEmail && userService.userPermissions.isInternalOrbitUser	,
			enabled: true,
			actionEnabled: dataModel.canSendConfirmationEmail,
			actionDisabledMessage: '',
			iconName: 'send',
			actionName: 'sendConfirmation',
			hoverText: 'Send Confirmation Email',
			class: '',
			buttonText: '',
			popover: '',
		};

		this.processActions.push(this.editButton);
		this.processActions.push(this.sendConfirmationButton);
	}
}
